// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
import { dumpObj } from "@nevware21/ts-utils";
import { _DYN_ITEMS_RECEIVED, _DYN_LENGTH, _DYN_NAME } from "../__DynamicConstants";
import { STR_EMPTY } from "../constants/InternalConstants";
import { _throwInternal } from "../diagnostics/DiagnosticLogger";
import { getJSON } from "../utils/EnvUtils";
/**
 * Parses the response from the backend.
 * @param response - XMLHttpRequest or XDomainRequest response
 */
export function parseResponse(response, diagLog) {
    try {
        if (response && response !== STR_EMPTY) {
            var result = getJSON().parse(response);
            if (result && result[_DYN_ITEMS_RECEIVED /* @min:%2eitemsReceived */] && result[_DYN_ITEMS_RECEIVED /* @min:%2eitemsReceived */] >= result.itemsAccepted &&
                result.itemsReceived - result.itemsAccepted === result.errors[_DYN_LENGTH /* @min:%2elength */]) {
                return result;
            }
        }
    }
    catch (e) {
        _throwInternal(diagLog, 1 /* eLoggingSeverity.CRITICAL */, 43 /* _eInternalMessageId.InvalidBackendResponse */, "Cannot parse the response. " + (e[_DYN_NAME /* @min:%2ename */] || dumpObj(e)), {
            response: response
        });
    }
    return null;
}
//# sourceMappingURL=ResponseHelpers.js.map